<template>
  <div
    class="z-top absolute-full"
    data-test-id="scroll-zoom-animation"
    style="pointer-events: none;"
  >
    <div class="scroll-downs">
      <div class="mousey">
        <div class="scroller" />
      </div>
      <div class="text-responsive q-py-sm text-no-wrap text-bold text-body1 text-center">
        {{ $t('seatChart.scrollZoom') }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ScrollZoomAnimation'
}

</script>
<style lang="scss" scoped>
.scroll-downs {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto auto 80px auto;
  width :100px;
  height: 55px;
}
.body--dark .mousey {
  width: 3px;
  padding: 10px 15px;
  height: 35px;
  border: 2px solid #fff;
  border-radius: 25px;
  opacity: 0.75;
  box-sizing: content-box;
  margin: auto;
  transform: scale(0.8);
}
.body--light .scroller {
  width: 3px;
  height: 10px;
  border-radius: 25%;
  background-color: rgba(0, 0, 0, 0.5);
  animation-name: scroll;
  animation-duration: 2.2s;
  animation-timing-function: cubic-bezier(.15,.41,.69,.94);
  animation-iteration-count: infinite;
}
.body--light .mousey {
  width: 3px;
  padding: 10px 15px;
  height: 35px;
  border: 2px solid rgba(0, 0, 0, 0.5);
  border-radius: 25px;
  opacity: 0.75;
  box-sizing: content-box;
  margin: auto;
  transform: scale(0.8);
}
.body--dark .scroller {
  width: 3px;
  height: 10px;
  border-radius: 25%;
  background-color: #fff;
  animation-name: scroll;
  animation-duration: 2.2s;
  animation-timing-function: cubic-bezier(.15,.41,.69,.94);
  animation-iteration-count: infinite;
}
@keyframes scroll {
  0% { opacity: 0; }
  10% { transform: translateY(0); opacity: 1; }
  100% { transform: translateY(15px); opacity: 0;}
}
</style>
